import React, {useState} from "react";
import MetaTags from 'react-meta-tags';
import { Link } from "react-router-dom";
import { Col, Container, Form, Row, Input, Label, Dropdown, FormFeedback } from "reactstrap";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// import images
import logodark from "../../assets/images/logo-dark.png";
import logolight from "../../assets/images/bridge-logo.png";
import CarouselPage from "./CarouselPage";

import axios from "axios";
import * as url from "../../helpers/url_helper"
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { TOAST_OPTIONS2, HRConfig2 } from "helpers/backend_helper";
import { useHistory } from "react-router-dom";

const PublicApplicantsLogin = () => {
    const [passwordShow, setPasswordShow] = useState(false);
    const history = useHistory();
    toastr.options = TOAST_OPTIONS2;
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    
    const validation = useFormik({
      enableReinitialize: true,
  
      initialValues: {
        email:  '',
        password: '',
      },
      validationSchema: Yup.object({
        email: Yup.string().required("Please Enter Your Email"),
        password: Yup.string().required("Please Enter Your Password"),
      }),
      onSubmit: (values) => {
        setIsLoading(true)
        axios.post(url.APPLICANT_LOGIN, JSON.stringify(values), HRConfig2)
        .then((r)=>{
            if(r.data.success == 1){
                localStorage.setItem("authApplicant", JSON.stringify(r.data.applicant))
                if(r.data.applicant.user_must_change_password == 'Yes'){
                  // history.push("/change-password")
                  // toastr.info("Change Password"); 
                  history.push("/applications")
                }else{
                  toastr.success(r.data.message); 
                  history.push("/applications")
                }
              }else{
              toastr.error(r.data.message)
            }
        })
        .catch((e)=>{
            console.log(e)
            setIsLoading(false)
        })
      }
    });
    

  return (
    <React.Fragment>
        <MetaTags>
          <title>Login | MILDMAY E-Recruitment</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col xl={8}>
            <CarouselPage />
            </Col>

            <Col xl={4}>
              <div className="auth-full-page-content p-md-5 p-4" style={{ backgroundColor: 'white' }}>
                <div className="w-100">
                  <div className="d-flex flex-column h-80">
                    <div className="mb-4 mb-md-5">
                      <Link to="#" className="d-block auth-logo">
                        <img
                          src={logodark}
                          alt=""
                          height="60"
                          className="auth-logo-dark"
                        />
                        <img
                          src={logolight}
                          alt=""
                          height="60"
                          className="auth-logo-light"
                        />
                      </Link>
                    </div>
                    <div className="my-auto">
                      <div>
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p className="text-muted">
                          Sign in to continue with your job application...
                        </p>
                      </div>                  
                    
                      <div className="mt-4">
                      <Form 
                        className="form-horizontal"
                          onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                          }}
                        >
                          <div className="mb-3">
                            <Label className="form-label">Email</Label>
                            <Input
                              name="email"
                              className="form-control"
                              type="email"
                              placeholder="Enter email"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.email || ""}
                              invalid={
                                validation.touched.email && validation.errors.email ? true : false
                              }
                            />
                            {validation.touched.email && validation.errors.email ? (
                              <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                            ) : null}
                          </div>

                          <div className="mb-3">
                          <div className="float-end">
                            <Link to="/applicant-reset-password" className="text-muted">
                              <i className="mdi mdi-lock me-1" />
                              Forgot your password?
                            </Link>
                            </div>
                          
                          <Label className="form-label">Password</Label>
                          <div className="input-group auth-pass-inputgroup">
                            <Input
                              name="password"
                              value={validation.values.password || ""}
                              type={passwordShow ? "text" : "password"}
                              placeholder="Enter Password"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.password && validation.errors.password ? true : false
                              }
                            />
                            <button onClick={() => setPasswordShow(!passwordShow)} className="btn btn-light " type="button" id="password-addon">
                                <i className="mdi mdi-eye-outline"></i></button>
                            {validation.touched.password && validation.errors.password ? (
                              <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                            ) : null}
                          </div>
                          </div>

                          

                          
                          <div className="form-check">
                          </div>

                          <div className="hstack gap-2">
                            <button className="btn btn-primary btn-block w-100" type="submit"><i className="mdi mdi-login-variant"/>{"  "}Log In</button>                            
                            <button className="btn btn-info btn-block w-100" type="button" onClick={() => {history.push(`/applicants-registration`)}} ><i className="mdi mdi-shield-account"/>{"  "}Create Account</button>
                          </div>

                        </Form>
                      </div>
                      <div className="mt-4 text-center">  
                        <p>
                          Access Staff Portal:{" "}
                          <Link to="/login" className="fw-medium text-primary">
                            {"  "}
                            E-Hub{" "}
                          </Link>{" "}
                        </p>
                      </div>
                      </div>
                    
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

    </React.Fragment>
  );
};

export default PublicApplicantsLogin;
